import clsx from "clsx";
import { useEffect, useState } from "react";

import useSiteConfigUnAuth from "../api/sanity/queries/getSiteConfigWithDomain";
import LanguageSelector from "../components/LanguageSelector";
import useGetColours from "../helpers/getColours";
import { useSyncThemeStore } from "../hooks/useSyncThemeStore";
// import AppState from "../store/appstate";
import useAppStore from "../store/appStateZustand";
import Loading from "./Loading";
// import useSiteConfigAuth from '../api/sanity/queries/getSiteConfigWithCode';

function BasicLayout(props) {
  const { children } = props;
  const { data: domainConfig, isSuccess: domainConfigIsSuccess } = useSiteConfigUnAuth();
  const { onboardingDarkColour, grad1Colour, grad2Colour } = useGetColours();
  const clientDisplayName = domainConfig?.display_name;
  const isProduction = import.meta.env.VITE_STAGE === "prd";

  // Temporary override for testing - set to true to force TuneCore mode
  const [FORCE_TUNECORE_MODE, setForceTunecoreMode] = useState(false);

  const isTunecore = FORCE_TUNECORE_MODE || domainConfig?.display_name === "TuneCore";

  // Sync theme stores - handles both local UI state and shared @sentricmusic/ui theme
  useSyncThemeStore(isTunecore, domainConfigIsSuccess && !!domainConfig);

  // AppState.update((s) => {
  //   s.hubspotDisabled = domainConfig?.disable_hubspot_tracking;
  // });
  useEffect(() => {
    if (domainConfig?.disable_hubspot_tracking !== undefined) {
      useAppStore.setState({ hubspotDisabled: domainConfig.disable_hubspot_tracking });
    }
  }, [domainConfig?.disable_hubspot_tracking]);

  const basicLayoutClasses = clsx({
    "font-tunecore": isTunecore,
    "font-sentric": !isTunecore,
  });

  useEffect(() => {
    if (domainConfigIsSuccess) {
      document.title = `${domainConfig?.display_name} Portal`;
    }
  }, [domainConfigIsSuccess, domainConfig?.display_name]);

  useEffect(() => {
    if (clientDisplayName) {
      // AppState.update((s) => {
      //   s.clientDisplayName = clientDisplayName;
      // });
      useAppStore.setState({ clientDisplayName });
    }
  }, [clientDisplayName]); // clientDisplayName is derived from domainConfig.display_name

  if (!domainConfig || !grad1Colour || !grad2Colour) {
    return <Loading />;
  }

  return (
    <>
      <div className={`flex flex-col h-screen ${basicLayoutClasses}`}>
        <div style={{ backgroundColor: onboardingDarkColour }} className="p-6">
          {domainConfig?.logo && (
            <img className="h-6 lg:h-12" src={domainConfig.logo} alt="logo" />
          )}
        </div>
        <div
          style={{ backgroundColor: onboardingDarkColour }}
          className="flex flex-col items-center justify-center text-white grow"
        >

          <div className="absolute top-0 right-0 flex flex-row-reverse items-center gap-3 pt-3">
            <LanguageSelector />
            {!isProduction && !domainConfig?.demo_mode && (
              <label className="flex items-center gap-1 text-xs text-white cursor-pointer">
                <input
                  type="checkbox"
                  checked={FORCE_TUNECORE_MODE}
                  onChange={e => setForceTunecoreMode(e.target.checked)}
                  className="w-5 h-5 accent-sentric-teal"
                />
                <span className="text-white uppercase font-sentric">
                  TuneCore Mode
                </span>
              </label>
            )}
          </div>

          {children}
        </div>
        <div
          style={{
            position: "fixed",
            bottom: "10px",
            right: "10px",
            padding: "6px",
          }}
          className="text-xs text-ink-secondary"
        >
          &copy;
          {" "}
          {domainConfig?.display_name}
          {" "}
          2024
        </div>
      </div>
    </>
  );
}
export default BasicLayout;
